var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"player",staticClass:"agora-video-player",attrs:{"id":_vm.domId}})
}
var staticRenderFns = []

export { render, staticRenderFns }